import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'
import { ReportsTabOption } from '@dataTypes/reports.type'

export type UnscheduledTreatmentView = 'Patients' | 'Revenue'

export const UNSCHEDULED_TREATMENT_VIEW_TABS: ReportsTabOption<UnscheduledTreatmentView>[] =
  [
    { label: 'Patients', value: 'Patients' },
    { label: 'Revenue', value: 'Revenue' },
  ]

export const PATIENT_RISK_COMPLIANCE_FILTERS = REPORTS_DEFAULT_FILTERS

export type MedicalAlertCategoryRow = {
  id: string
  category: string
  patients: number
}

export const PATIENT_RISK_COMPLIANCE_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'count'
  unitInline?: string
  footerMode?:
    | 'percentChange'
    | 'pointChange'
    | 'percentOfPriorBase'
    | 'descriptor'
}> = [
  {
    id: 'unscheduled-treatments',
    title: 'Patients w/ unscheduled treatments',
    footer: '',
    format: 'count',
    footerMode: 'percentChange',
  },
  // Recall Compliance Rate — hidden until recall feature is available.
  {
    id: 'medical-alerts',
    title: 'Patients w/ medical alerts',
    footer: '',
    format: 'count',
    unitInline: 'patients',
    footerMode: 'percentChange',
  },
  {
    id: 'overdue-6',
    title: 'Patients overdue (6+ months)',
    footer: '',
    format: 'count',
    unitInline: 'patients',
    footerMode: 'percentChange',
  },
]
